import { render, staticRenderFns } from "./restore.vue?vue&type=template&id=0ba32a70&scoped=true"
import script from "./restore.vue?vue&type=script&lang=js"
export * from "./restore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba32a70",
  null
  
)

export default component.exports